<div class="pizza-game" [class.is-immersive]="isFullscreen" *ngIf="round">

  <!-- Round progress -->
  <div class="round-dots">
    <span class="dot" *ngFor="let d of roundDots; let i = index"
          [class.done]="solvedFlags[i]" [class.current]="i === currentRound"></span>
  </div>

  <!-- Single play panel: order header + interactive board on one rounded surface -->
  <div class="play-panel">

    <!-- Order header (the fraction to serve) — folded into the top of the board.
         The turn badge lives on this SAME row (trailing edge), so question +
         student card read as one aligned header line (§3.7). Mirrors in RTL. -->
    <div class="panel-head">
      <div class="head-order">
        <span class="order-label">{{ currLang === 'ar' ? '🍕 الطلب' : '🍕 Order' }}</span>
        <span class="fraction">
          <span class="num">{{ aNum }}</span><span class="bar"></span><span class="den">{{ den }}</span>
        </span>
        <span class="op">{{ opSign }}</span>
        <span class="fraction">
          <span class="num">{{ bNum }}</span><span class="bar"></span><span class="den">{{ den }}</span>
        </span>
        <span class="op">=</span>
        <span class="q">?</span>
      </div>

      <!-- Whose turn — pinned to the trailing edge of the question row -->
      <div class="turn-chip" *ngIf="student">
        <app-student-avatar [student]="student" [size]="46" [active]="true"></app-student-avatar>
        <div class="turn-text">
          <span class="turn-name">{{ studentName }}</span>
          <span class="turn-label">{{ currLang === 'ar' ? 'دورك!' : "it's your turn" }}</span>
        </div>
      </div>
    </div>

    <!-- Interactive board -->
    <div class="board-area">
      <app-cutting-pizza-stage
        [round]="round"
        [roundKey]="currentRound"
        [hintVisible]="hintVisible"
        [interactive]="!resolving && !showTurnCard"
        [currLang]="currLang"
        (solved)="onSolved()"
        (missed)="onMissed()">
      </app-cutting-pizza-stage>
    </div>

    <!-- Kind failed-try feedback (theme §3.2): a PERSISTENT element toggled by
         opacity only (never created/destroyed → no flicker). On a wrong serve
         Chef Nino fades in beside a warm, growth-mindset line that never reveals
         the answer; the copy rotates. pointer-events:none so the board stays live. -->
    <div class="chef-encourage" [class.is-visible]="showChef" aria-live="polite">
      <svg class="chef-portrait" viewBox="0 0 120 136" aria-hidden="true">
        <!-- Toque (back puffs + band) -->
        <circle cx="38" cy="34" r="17" fill="#FFFFFF" stroke="#DCE3ED" stroke-width="1.5"/>
        <circle cx="82" cy="34" r="17" fill="#FFFFFF" stroke="#DCE3ED" stroke-width="1.5"/>
        <circle cx="60" cy="24" r="20" fill="#FFFFFF" stroke="#DCE3ED" stroke-width="1.5"/>
        <circle cx="30" cy="44" r="13" fill="#FFFFFF" stroke="#DCE3ED" stroke-width="1.5"/>
        <circle cx="90" cy="44" r="13" fill="#FFFFFF" stroke="#DCE3ED" stroke-width="1.5"/>
        <rect x="30" y="48" width="60" height="16" rx="8" fill="#FFFFFF" stroke="#DCE3ED" stroke-width="1.5"/>
        <!-- Coat shoulders -->
        <path d="M14 136 C16 112 30 102 44 100 L76 100 C90 112 106 112 106 136 Z" fill="#FFFFFF" stroke="#DCE3ED" stroke-width="1.5"/>
        <circle cx="50" cy="124" r="2.4" fill="#FDB022"/>
        <circle cx="50" cy="132" r="2.4" fill="#FDB022"/>
        <!-- Red neckerchief knot + bands -->
        <path d="M60 108 L50 128 L58 126 L60 116 L62 126 L70 128 Z" fill="#C42E24"/>
        <circle cx="60" cy="112" r="6" fill="#F04438"/>
        <!-- Face -->
        <circle cx="34" cy="84" r="6" fill="#F4BC94" stroke="#D89A6B" stroke-width="1.5"/>
        <circle cx="86" cy="84" r="6" fill="#F4BC94" stroke="#D89A6B" stroke-width="1.5"/>
        <circle cx="60" cy="82" r="27" fill="#F4BC94" stroke="#D89A6B" stroke-width="1.5"/>
        <!-- Brows -->
        <path d="M45 72 Q52 68 58 72" stroke="#7A4A2A" stroke-width="3.2" stroke-linecap="round" fill="none"/>
        <path d="M62 72 Q68 68 75 72" stroke="#7A4A2A" stroke-width="3.2" stroke-linecap="round" fill="none"/>
        <!-- Eyes -->
        <ellipse cx="52" cy="79" rx="6" ry="6.5" fill="#FFFFFF"/>
        <ellipse cx="68" cy="79" rx="6" ry="6.5" fill="#FFFFFF"/>
        <circle cx="53" cy="80" r="4" fill="#43331F"/>
        <circle cx="67" cy="80" r="4" fill="#43331F"/>
        <circle cx="54.5" cy="78.5" r="1.3" fill="#FFFFFF"/>
        <circle cx="68.5" cy="78.5" r="1.3" fill="#FFFFFF"/>
        <!-- Cheeks -->
        <circle cx="44" cy="90" r="4" fill="#F1917B" opacity="0.45"/>
        <circle cx="76" cy="90" r="4" fill="#F1917B" opacity="0.45"/>
        <!-- Nose -->
        <ellipse cx="60" cy="88" rx="3.2" ry="2.6" fill="#EEA97C"/>
        <!-- Handlebar mustache -->
        <path d="M60 96 C52 92 44 92 38 98 C44 102 52 101 60 98 C68 101 76 102 82 98 C76 92 68 92 60 96 Z" fill="#6E4423"/>
        <!-- Open grin -->
        <path d="M50 100 Q60 112 70 100 Q60 106 50 100 Z" fill="#A6432B"/>
        <rect x="52" y="100" width="16" height="3" rx="1.5" fill="#FFFFFF"/>
        <ellipse cx="60" cy="106" rx="4" ry="2.4" fill="#E5705A"/>
        <!-- Flour dust -->
        <circle cx="40" cy="74" r="1.2" fill="#FFFFFF" opacity="0.85"/>
        <circle cx="80" cy="76" r="1.1" fill="#FFFFFF" opacity="0.85"/>
        <circle cx="70" cy="94" r="1" fill="#FFFFFF" opacity="0.85"/>
      </svg>
      <div class="chef-bubble">
        <span class="chef-line">{{ currLang === 'ar' ? chefLine.ar : chefLine.en }}</span>
      </div>
    </div>
  </div>

  <!-- Controls -->
  <div class="controls">
    <button class="ctrl-btn serve-btn" [disabled]="resolving || firing || showTurnCard" (click)="onServe()">
      <span aria-hidden="true">🍽️</span>
      {{ currLang === 'ar' ? 'قدّم' : 'SERVE' }}
    </button>

    <button class="ctrl-btn skip-btn" [disabled]="resolving" (click)="skip()">
      {{ currLang === 'ar' ? 'تخطّي' : 'Skip' }}
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>

  <!-- Success -->
  <div class="success-overlay" *ngIf="showSuccess">
    <div class="success-card">
      <div class="success-icon" aria-hidden="true">🍕</div>
      <div class="success-title">{{ currLang === 'ar' ? 'طلب مثالي!' : 'Perfect order!' }}</div>
      <div class="success-xp" *ngIf="lastXp > 0">+{{ lastXp }} XP</div>
    </div>
  </div>

  <!-- Turn-intro card -->
  <div class="turn-card-overlay" *ngIf="showTurnCard" (click)="dismissTurnCard()">
    <div class="turn-card">
      <div class="tc-emoji" aria-hidden="true">🍕</div>
      <app-student-avatar *ngIf="student" [student]="student" [size]="96" [active]="true"></app-student-avatar>
      <div class="tc-name">{{ studentName }}</div>
      <div class="tc-label">{{ currLang === 'ar' ? 'دورك!' : "It's your turn" }}</div>
      <div class="tc-tap">{{ currLang === 'ar' ? 'انقر للبدء' : 'tap to start' }}</div>
    </div>
  </div>

  <!-- Own fullscreen button — matches the bottom-left "Select Game" chrome button
       (§3.7), pinned bottom-right via inset-inline-end so it mirrors in RTL. NOT the
       shared <app-fullscreen-toggle> (which is a mismatched dark/gold pill). -->
  <button class="fs-btn" type="button" (click)="toggleFullscreen()"
          [attr.aria-label]="isFullscreen
            ? (currLang === 'ar' ? 'تصغير' : 'Minimize')
            : (currLang === 'ar' ? 'ملء الشاشة' : 'Fullscreen')"
          [title]="isFullscreen
            ? (currLang === 'ar' ? 'تصغير' : 'Minimize')
            : (currLang === 'ar' ? 'ملء الشاشة' : 'Fullscreen')">
    <!-- Minimize: corner-in arrows -->
    <svg *ngIf="isFullscreen" width="18" height="18" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M8 3v5H3"/><path d="M21 8h-5V3"/><path d="M16 21v-5h5"/><path d="M3 16h5v5"/>
    </svg>
    <!-- Fullscreen: corner-out arrows -->
    <svg *ngIf="!isFullscreen" width="18" height="18" viewBox="0 0 24 24" fill="none"
         stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
      <path d="M3 8V3h5"/><path d="M16 3h5v5"/><path d="M21 16v5h-5"/><path d="M8 21H3v-5"/>
    </svg>
    <span class="fs-label">{{ isFullscreen
      ? (currLang === 'ar' ? 'تصغير' : 'Minimize')
      : (currLang === 'ar' ? 'ملء الشاشة' : 'Fullscreen') }}</span>
  </button>
</div>
